import { useListContext } from 'react-admin';

import {
  ServerExportButton,
  useExportNeedsConfirmation,
} from '@sh4res/bo-common/components/ServerExportButton';
import { useResourceBasePath } from '@sh4res/bo-common/hooks/useResourceBasePath';

/** The employees of the list, as its current filters and sort select them, in a bulk create file */
export const EmployeesBulkExportButton = ({
  kind,
  label,
  'data-testid': dataTestId,
}: {
  kind: 'employees_bulk' | 'employees_bulk_multi_company';
  label?: string;
  'data-testid'?: string;
}) => {
  const resourceBasePath = useResourceBasePath();
  const { filterValues, sort, total } = useListContext();
  const needsConfirmation = useExportNeedsConfirmation();

  return (
    <ServerExportButton
      resource={`${resourceBasePath}employees`}
      label={label}
      disabled={total === 0}
      needsConfirmation={needsConfirmation}
      getBody={() => ({
        kind,
        query: {
          filter: JSON.stringify(filterValues),
          sort: JSON.stringify([sort.field, sort.order]),
        },
      })}
      data-testid={dataTestId}
    />
  );
};
